import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/conformita-ai-act")({
  head: () => seoMeta({
    title: "LexAIPro e l'AI Act europeo: classificazione e conformità",
    description: "Come LexAIPro rispetta il Regolamento UE 2024/1689 (AI Act): trasparenza, supervisione umana, gestione del rischio.",
    path: "/conformita-ai-act",
  }),
  component: () => (
    <ContentPage
      eyebrow="Conformità"
      title="Conformità all'AI Act europeo"
      lead="LexAIPro è un sistema di AI generale di supporto alla professione legale. Rispettiamo gli obblighi di trasparenza, supervisione umana e gestione del rischio previsti dal Regolamento UE 2024/1689."
      breadcrumbs={[{name:"Home",path:"/"},{name:"AI Act",path:"/conformita-ai-act"}]}
      sections={[
        { heading: "Classificazione del sistema", body: "LexAIPro è uno strumento di assistenza professionale. Non prende decisioni autonome; supporta il giudizio dell'avvocato. Non rientra nei sistemi ad alto rischio dell'Allegato III." },
        { heading: "Misure adottate", bullets: ["Trasparenza: indicazione esplicita dell'uso di AI in ogni output","Supervisione umana obbligatoria su ogni decisione","Documentazione tecnica conforme","Valutazione del rischio aggiornata","Logging delle interazioni per auditabilità"] },
      ]}
      cta={{ label: "Approfondisci la sicurezza", to: "/sicurezza" }}
      heroImage={pickContent(15)}
      updated="2026"
    />
  ),
});
